import {
  closestCorners,
  type Collision,
  type CollisionDetection,
  pointerWithin,
} from '@dnd-kit/core';

import { LEAD_STATUS_IDS } from '@/core/components/leads/lead-status-colors';

/** Wenn Pointer/Overlay gleichzeitig Spalte und Karte treffen: Karte gewinnt. */
export function preferLeadCardOverColumnPlates(
  collisions: Collision[],
): Collision[] {
  if (collisions.length <= 1) return collisions;
  const nonColumn = collisions.filter(
    (c) =>
      !LEAD_STATUS_IDS.includes(
        String(c.id) as (typeof LEAD_STATUS_IDS)[number],
      ),
  );
  if (nonColumn.length > 0) return nonColumn;
  return collisions;
}

export const kanbanBoardCollisionDetection: CollisionDetection = (args) => {
  let collisions = pointerWithin(args);
  if (collisions.length === 0) {
    collisions = closestCorners(args);
  }
  return preferLeadCardOverColumnPlates(collisions);
};
